import Vue from 'vue';

Vue.mixin({
    data: function () {
        return {
            screenWidth: 0,
            $resizeListener: null
        }
    },
    created() {
        this.$resizeListener = this.onResize.bind(this)
        this.addResizeListener();
        this.$resizeListener();
    },
    destroyed() {

    },
    computed: {
        isMobile() {
            return this.screenWidth <= 1100;
        }
    },
    methods: {
        addResizeListener() {
            window.addEventListener('resize', this.$resizeListener);
        },
        removeResizeListener() {
            window.removeEventListener('resize', this.$resizeListener);
        },
        onResize(e) {
            this.screenWidth = window.innerWidth;
        }
    }
});

